<template>
  <el-dialog
    class="dialog-wrapper expected-values"
    visible
    :show-close="false"
    :append-to-body="appendToBody"
    @close="abortAssociation"
  >
    <ContentHeader
      slot="title"
      :title="$t('analysesData.associateLocation.title')"
    />
    <ValidationObserver
      ref="expectedValuesForm"
      v-slot="{ handleSubmit, invalid }"
    >
      <el-form
        ref="form"
        label-position="top"
      >
        <el-row
          :gutter="20"
          type="flex"
        >
          <el-col :span="6">
            <FormItem
              rules="required"
              :label="$t('analysesData.associateLocation.location')"
            >
              <el-autocomplete
                v-model="formData.locationName"
                style="width: 100%"
                :fetch-suggestions="locationsList"
                :trigger-on-focus="false"
                value-key="label"
                clearable
                placeholder=""
                @select="
                  (item) => {
                    formData.locationId = item.value;
                    formData.locationName = item.label;
                  }
                "
              >
                <template slot-scope="{ item }">
                  <AutocompleteItem :item="item" />
                </template>
              </el-autocomplete>
            </FormItem>
          </el-col>
        </el-row>

        <FormButtons>
          <el-button
            type="secondary"
            @click.prevent="abortAssociation"
          >
            {{ $t('global.cancel') }}
          </el-button>
          <el-button
            type="primary"
            native-type="submit"
            :disabled="invalid"
            @click.prevent="handleSubmit(associateLocation)"
            :loading="loading"
          >
            {{ $t('global.confirm') }}
          </el-button>
        </FormButtons>
      </el-form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
  import { laboratories } from '@/config/constants';
  import { locationsManagementApi, analysesDataApi } from '@/api';

  import ContentHeader from '@/components/ContentHeader.vue';
  import FormButtons from '@/components/FormButtons.vue';
  import FormItem from '@/components/FormItem.vue';
  import AutocompleteItem from '@/components/AutocompleteItem.vue';

  const defaultData = {
    laboratory: laboratories.CHIM,
    locationId: '',
    locationName: '',
  };

  export default {
    name: 'AssociateLocation',
    components: {
      ContentHeader,
      FormButtons,
      FormItem,
      AutocompleteItem,
    },
    props: {
      sample: { type: Object, default: () => {} },
      appendToBody: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...defaultData },
        loading: false,
      };
    },
    methods: {
      async associateLocation() {
        this.loading = true;
        try {
          await analysesDataApi.patchLocation(this.sample.labSampleAnalysisId, {
            locationId: this.formData.locationId,
          });
          this.$notify({
            showClose: true,
            type: 'success',
            message: this.$t('quarantine.update.success'),
          });
          this.$emit('dialogClose', { success: true });
          this.formData = { ...defaultData };
          this.loading = false;
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
          this.loading = false;
        }
      },
      abortAssociation() {
        this.$emit('dialogClose', { success: false });
      },
      async locationsList(value, cb) {
        if (value && value.length >= 3) {
          const response = await locationsManagementApi.autocompleteFetch(
            'name',
            value,
            false
          );
          const locations = response.data.map((c) => ({
            label: c.name,
            value: c.id,
          }));
          cb(locations);
        } else {
          cb([]);
        }
      },
    },
  };
</script>
